// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-list-bg[data-v-3329fc78]{background:linear-gradient(59deg,#f40,#ff8100,#ffc238)}.tag-items[data-v-3329fc78] .v-btn{letter-spacing:normal!important}", ""]);
// Exports
module.exports = exports;
